export const loadPage = () => {
  console.log("Loaded");
};
